module.exports = __webpack_public_path__ + "img/s2-hx-2.be382f12.png";